import { combineReducers } from 'redux'

import bookingFilters from './bookingFilters'
import bookingListFilters from './bookingListFilters'
import orderFilters from './orderFilters'
import projectChangesFilters from './projectChangesFilters'
import projectOrderFilters from './projectOrderFilters'
import taskFilters from './taskFilters'

export default combineReducers({
  bookingFilters,
  bookingListFilters,
  orderFilters,
  projectChangesFilters,
  projectOrderFilters,
  taskFilters,
})
